import React from 'react'
import styled from 'styled-components'
import media from '../styles/media'

import { ReactComponent as TargetLightSVG } from '../assets/svg/targetLight.svg'
import { ReactComponent as TargetDarkSVG } from '../assets/svg/targetDark.svg'

type Props = {
  menuOpen: boolean
  isDarkMode?: boolean
}

const Target: React.FC<Props> = ({ menuOpen, isDarkMode }) => {
  return (
    <Wrapper open={menuOpen} className="vert-header__target">
      {isDarkMode ? <TargetObj /> : <TargetDark />}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ open: boolean }>`
  position: fixed;
  width: 13px;
  right: ${(props) => (props.open ? '832px' : '88px')};
  transition-property: right;
  transition-timing-function: ${(props) =>
    props.open
      ? 'cubic-bezier(0.12, 1, 0.72, 1)'
      : 'cubic-bezier(0.72, 0, 0.12, 1)'};
  transition-duration: ${(props) => (props.open ? '800ms' : '1000ms')};
  top: 89px;
  z-index: 99999;
  ${media.tabletLandscape} {
    right: ${(props) => (props.open ? '832px' : '-7px')};
    top: 42px;
  }
  ${media.tablet} {
    right: ${(props) => (props.open ? 'calc(96.8vw - 7px)' : '-7px')};
  }
`

const TargetObj = styled(TargetLightSVG)`
  position: relative;
  display: block;
  width: 13px;

  ${media.tablet} {
  }
`
const TargetDark = styled(TargetDarkSVG)`
  position: relative;
  display: block;
  width: 13px;
`
export default Target
